// src/store/store.js
import { createStore } from 'vuex';
import axios from 'axios';
import baseUrl from '../api';  // Asumiendo que tienes un archivo api.js con la URL base de tu API

const store = createStore({
  state() {
    return {
      id_usuario: localStorage.getItem('id_usuario') || null, // Recupera el id_usuario desde localStorage
      permisos: localStorage.getItem('permisos') || null, // Recupera permisos desde localStorage
    };
  },
  mutations: {
    setIdUsuario(state, id) {
      state.id_usuario = id;
      localStorage.setItem('id_usuario', id); // Guardar id_usuario en localStorage para persistencia
    },
    setPermisos(state, permisos) {
      state.permisos = permisos;
      localStorage.setItem('permisos', permisos); // Guardar permisos en localStorage
      sessionStorage.setItem('permisos', permisos); // Guardar en sessionStorage para persistencia de sesión
    },
  },
  actions: {
    // Acción para iniciar sesión y obtener permisos
    async login({ commit }, id_usuario) {
      commit('setIdUsuario', id_usuario); // Guardar el id_usuario
      try {
        const response = await axios.get(`${baseUrl}/permisos/${id_usuario}`);
        console.log('Permisos recuperados desde la API:', response.data.permisos);

        commit('setPermisos', response.data.permisos); // Guardar los permisos en Vuex y en localStorage
      } catch (error) {
        console.error('Error al obtener los permisos:', error);
      }
    },
    // Cargar los datos del usuario desde el almacenamiento
    loadFromStorage({ commit }) {
      const id_usuario = localStorage.getItem('id_usuario');
      const permisos = localStorage.getItem('permisos');
      if (id_usuario && permisos) {
        commit('setIdUsuario', id_usuario);
        commit('setPermisos', permisos);
      }
    },
  },
  getters: {
    // Un getter para acceder a los datos del usuario y permisos
    isLoggedIn(state) {
      return state.id_usuario !== null && state.permisos !== null;
    },
  },
});

export default store;
